import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ADD_ANNOUNCEMENT_COMPONENT_CONSTS } from '@app/config/constants';
import { urlValidator } from '@app/shared/validators/url.validator';

@Component({
  selector: 'app-add-announcement',
  templateUrl: './add-announcement.component.html',
  styleUrls: ['./add-announcement.component.css']
})
export class AddAnnouncementComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<any>, public fb: FormBuilder, @Inject(MAT_DIALOG_DATA) public data) {}

  consts = ADD_ANNOUNCEMENT_COMPONENT_CONSTS;
  minDate = new Date();
  maxDate = new Date(this.minDate.getTime() + this.consts.GAP_BETWEEN_MINDATE_TO_MAXDATE);
  editForm: FormGroup;
  recipientList = [];
  hoursList = [];
  userPermission: any;

  ngOnInit(): void {
    this.userPermission = this.data.userPermission;
    this.populateRecipientList(this.userPermission.permissionLevels);
    this.populateHoursList();
    this.editForm = this.fb.group({
      team: ['', [Validators.required]],
      message: ['', [Validators.required]],
      link: [null, [urlValidator]],
      isTopBanner: [null],
      startDateDatePart: [null, [Validators.required]],
      startDateHourPart: ['00:00', [Validators.required]],
      endDateDatePart: [null, [Validators.required]],
      endDateHourPart: ['00:00', [Validators.required]]
    });
  }

  sendAnnouncement() {
    this.prepareValidator();

    if (!this.editForm.invalid && this.isDateRangeValid()) {
      const notification = this.populateNotification();
      this.dialogRef.close(notification);
    }
  }

  prepareValidator() {
    if (!this.editForm.value.link) {
      this.editForm.controls.link.removeValidators(urlValidator);
      this.editForm.controls.link.updateValueAndValidity();
    } else {
      this.editForm.controls.link.addValidators(urlValidator);
      this.editForm.controls.link.updateValueAndValidity();
    }
  }

  private uuidv4() {
    const u = Date.now().toString(16) + Math.random().toString(16) + '0'.repeat(16);
    const guid = [u.substring(0, 8), u.substring(8, 12), '4000-8' + u.substring(13, 16), u.substring(16, 28)].join('-');
    return guid;
  }

  private getUniqueID(): string {
    let uniqueID = crypto.randomUUID ? crypto.randomUUID() : this.uuidv4();
    return uniqueID;
  }

  populateNotification() {
    const startDate = this.getStartDate().toJSON();
    const endDate = this.getEndDate().toJSON();

    const notification = {
      announcementID: this.getUniqueID(),
      fullName: this.getFullName(),
      startDate: startDate,
      endDate: endDate,
      message: this.editForm.value.message,
      link: this.editForm.value.link,
      directReports: false,
      department: '',
      region: '',
      allDXC: false,
      isManager: false,
      isTopBanner: this.editForm.value.isTopBanner,
      createdAt: new Date().toJSON()
    };
    switch (this.editForm.value.team) {
      case this.consts.PERMISSIONLEVEL.REGION.lable:
        notification.region = this.userPermission.permissionLevels.region;
        break;
      case this.consts.PERMISSIONLEVEL.DEPARTMENT.lable:
        notification.department = this.userPermission.permissionLevels.department;
        break;
      case this.consts.PERMISSIONLEVEL.DIRECTREPORTS.lable:
        notification.directReports = true;
        break;
      case this.consts.PERMISSIONLEVEL.ALLDXC.lable:
        notification.allDXC = true;
        break;
      case this.consts.PERMISSIONLEVEL.MANAGERS.lable:
        notification.isManager = true;
        break;
    }
    return notification;
  }

  isDateRangeValid() {
    const startDate = this.getStartDate();
    const endDate = this.getEndDate();
    return startDate > new Date() && startDate < endDate;
  }

  private getEndDate() {
    return new Date(`${this.editForm.value.endDateDatePart} ${this.editForm.value.endDateHourPart}`);
  }

  private getStartDate() {
    return new Date(`${this.editForm.value.startDateDatePart} ${this.editForm.value.startDateHourPart}`);
  }

  private populateHoursList() {
    for (let index = 0; index < 24; index++) {
      const timeItem = index < 10 ? `0${index.toString()}:00` : `${index.toString()}:00`;
      this.hoursList.push(timeItem);
    }
  }

  private populateRecipientList(permissionLevels: {
    directReports: boolean;
    region: string;
    department: string;
    allDXC: boolean;
  }) {
    if (permissionLevels.directReports) {
      this.recipientList.push(this.consts.PERMISSIONLEVEL.DIRECTREPORTS);
    }
    if (permissionLevels.region && permissionLevels.region.length > 0) {
      this.recipientList.push({ ...this.consts.PERMISSIONLEVEL.REGION, data: ': ' + permissionLevels.region });
    }
    if (permissionLevels.department && permissionLevels.department.length > 0) {
      this.recipientList.push({ ...this.consts.PERMISSIONLEVEL.DEPARTMENT, data: ': ' + permissionLevels.department });
    }
    if (permissionLevels.allDXC) {
      this.recipientList.push(this.consts.PERMISSIONLEVEL.ALLDXC);
      this.recipientList.push(this.consts.PERMISSIONLEVEL.MANAGERS);
    }
  }

  private getFullName() {
    const user = JSON.parse(localStorage.getItem('user'));
    return `${user.givenName} ${user.surname}`;
  }
}
